import { useMemo } from "react";
import { useIntl } from "react-intl";
import commonMessages from "../../../common/messages";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      defaultError: formatMessage(commonMessages.defaultError),
      btnAddAddOn: formatMessage(messages.btnAddAddOn),
      titleAddAddOn: formatMessage(messages.titleAddAddOn),
      titleEditAddOn: formatMessage(messages.titleEditAddOn),
    };
  }, [formatMessage]);

  return translations;
};
export default useTranslations;
